<template>
  <div>
    <router-view></router-view>
    <modals />
  </div>
</template>
<script>
import Modals from './modals/Modals.vue'
export default {
  name: 'Main',

  components: {
    Modals
  }
}
</script>



// WEBPACK FOOTER //
// Main.vue?1bfe6d2c